import React, {useEffect, useState} from 'react';
import CartItem from '../components/CartItem';
import earring from '../pics/earring.png'
import gem from '../pics/gem-cartier.png'
import necklace from '../pics/necklace.png'
import ring from '../pics/ring.png'
import star from '../pics/star-bracelet.png'
import Search from '../components/SearchBar';
import ImageBox from '../components/ImageBox';

function Receipt(){

    let images = [
          {
             src: gem,
             name:"Cartier Bracelet",
             size:"M",
             price: "k200"
          },
          {
            src: earring,
            name:"Danna Dainty Bracelet",
            size:"S",
            price: "k175"
         },
         {
          src: necklace,
          name:"Akita Star Bracelet",
          size:"L",
          price: "k250"
       },
       {
          src: ring,
          name:"Akita Star Bracelet",
          size:"XL",
          price: "k250"
       },
         {
            src: earring,
            name:"Danna Dainty Bracelet",
            size:"S",
            price: "k175"
         },
         {
          src: necklace,
          name:"Akita Star Bracelet",
          size:"L",
          price: "k250"
       },
       {
          src: ring,
          name:"Akita Star Bracelet",
          size:"XL",
          price: "k250"
       }
      ]

   return(
    <div className='flex one column'>
      <div className='flex one center'>
         <p className='bold special-font'>Receipt</p>
      </div>
      <div className='flex five overflow gap column'>
         {images && images.length > 0 && (
            images.map(el =>{
               return(
                   <div className='receipt-item flex'>
                      <div className='flex one center'>
                            2
                      </div>
                      <div className='flex one center'>
                         <span>{el.name}</span>
                      </div>
                      <div className='flex one center'>
                        <span>{el.price}</span>
                      </div>
                   </div>
               )
            })
         )}
      </div>
      <div className='flex two column top-shadow'>
         <div className='flex one'>
             <div className='flex one center'>
               <span>Sub-total:</span>
            </div>
            <div className='flex one center'>
               <span className='bold'>k500</span>
            </div>
         </div>
         <div className='flex one'>
            <div className='flex one center'>
               <span>Discount:</span>
            </div>
            <div className='flex one center'>
               <span className='bold'>k50</span>
            </div>
         </div>
         <div className='flex one'>
            <div className='flex one center'>
               <span>Total:</span>
            </div>
            <div className='flex one center'>
               <span className='bold'>k450</span>
            </div>
         </div>
         <div className='flex two center'>
            <div className='checkout-btn flex center'>
               <span className='white-txt'>Download Receipt</span>
              </div>
         </div>
      </div>
    </div>
   )
}

export default Receipt